import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import styles from './index.css';
import { Comment } from 'ThreeTerminal_pc';

class CommentArea extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { commentConfig } = this.props.content;

        return <Comment articleInfo={commentConfig} />;
    }
}

export default errorBoundary(CommentArea);
